"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmissionChartGenerator = void 0;
;
var NUMBER_OF_VALUES = 10;
var COLORS = {
    'rail': '#87af28',
    'street': '#878787',
};
var EmissionChartGenerator = /** @class */ (function () {
    function EmissionChartGenerator() {
    }
    EmissionChartGenerator.generate = function (emission) {
        var maximum;
        var steps;
        var barRailHeight;
        var barStreetHeight;
        if (emission.rail > emission.street) {
            maximum = Math.ceil(emission.rail);
        }
        else {
            maximum = Math.ceil(emission.street);
        }
        steps = Math.ceil(maximum / NUMBER_OF_VALUES);
        steps = Math.ceil(steps / 10) * 10; // Round up to nearest ten
        var barRailHeightPercentage = (emission.rail * 100) / (NUMBER_OF_VALUES * steps);
        var barStreetHeightPercentage = (emission.street * 100) / (NUMBER_OF_VALUES * steps);
        barRailHeight = 1000 * (barRailHeightPercentage / 100);
        barStreetHeight = 1000 * (barStreetHeightPercentage / 100);
        return "\n\t\t\t<svg viewBox=\"0 0 1000 1000\" width=\"1000\" height=\"1100\" aria-labelledby=\"rcg-transfer-emission-chart-title\" aria-describedby=\"rcg-transfer-emission-chart-description\" role=\"img\" class=\"rcg-transfer__emission-chart\">\n\t\t\t\t<g class=\"lines\">\n\t\t\t\t\t".concat((function () {
            var lines = [];
            for (var i = 0; i <= NUMBER_OF_VALUES; i++) {
                lines.push("<line x1=\"140\" y1=\"".concat(i * 100, "\" x2=\"1000\" y2=\"").concat(i * 100, "\" />"));
            }
            return lines.join('');
        })(), "\n\n\t\t\t\t\t").concat((function () {
            var lineCaptions = [];
            for (var i = 0; i <= NUMBER_OF_VALUES; i++) {
                var caption = (i * steps).toLocaleString(EmissionChartGenerator.locale);
                lineCaptions.push("<text x=\"120\" y=\"".concat(Math.abs((i * 100) - 1000), "\">").concat(caption, "</text>"));
            }
            return lineCaptions.join('');
        })(), "\n\t\t\t\t</g>\n\n\t\t\t\t<g class=\"bars\">\n\t\t\t\t\t<rect x=\"230\" y=\"").concat(1000 - barRailHeight, "\" width=\"300\" height=\"").concat(barRailHeight, "\" fill=\"").concat(COLORS.rail, "\" />\n\t\t\t\t\t<rect x=\"540\" y=\"").concat(1000 - barStreetHeight, "\" width=\"300\" height=\"").concat(barStreetHeight, "\" fill=\"").concat(COLORS.street, "\" />\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t");
    };
    EmissionChartGenerator.generateLegendIcon = function (icon) {
        var color = icon === 'rail' ? COLORS.rail : COLORS.street;
        return "\n\t\t\t<span style=\"display: inline-block; width: 12px; height: 12px; background-color: ".concat(color, "\" aria-hidden=\"true\"></span>\n\t\t");
    };
    EmissionChartGenerator.locale = 'de';
    return EmissionChartGenerator;
}());
exports.EmissionChartGenerator = EmissionChartGenerator;
